import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { refreshAccessToken } from "./refreshAccessToken";
const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

const checktokenExpiryDate = (expiryDate) => {
  if (!expiryDate) return false;
  return new Date(expiryDate).getTime() > Date.now();
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authtoken");
  const tokenExpiry = localStorage.getItem("tokenExpiry");

  // No token at all
  if (!token) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  // Token invalid
  if (isTokenExpired(token)) {
    const isStillValid = checktokenExpiryDate(tokenExpiry);
    console.log("isStillValid", isStillValid);
    if (isStillValid) {
      refreshAccessToken(); // async refresh
      return children;
    } else {
      localStorage.clear();
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
